import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type { CreateAiThreadReplyInput } from '#/graphql/generated';

export interface CreateAiThreadReplyMutation {
  createAiThreadReply: { id: string };
}

export interface CreateAiThreadReplyMutationVariables {
  input: CreateAiThreadReplyInput;
}

export const CREATE_AI_THREAD_REPLY: TypedDocumentNode<
  CreateAiThreadReplyMutation,
  CreateAiThreadReplyMutationVariables
> = gql`
  mutation CreateAiThreadReply($input: CreateAiThreadReplyInput!) {
    createAiThreadReply(input: $input) {
      id
    }
  }
`;
